const openBtn = document.querySelector("#aside-information__opener");
const closeBtn = document.querySelector(".aside-panel__close-button");

const asideInfo = document.querySelector(".aside-information__inner-wrapper");
const asidePanel = document.querySelector(".aside-information__aside-panel");

const elementsForToggling = [
    asideInfo,
    asidePanel
]

function toggleElements(command, elements) {
    switch (command) {
        case "active":
            elements.forEach((el) => {
                el.dataset.active = "active";
            });
            break;

        case "disabled":
            elements.forEach((el) => {
                el.dataset.active = "disabled";
            });
            break;

        default:
            elements.forEach((el) => {
                el.dataset.active = "disabled";
            });
            break;
    }
}

function toggleScroll(command) {
    switch (command) {
        case "active":
            document.body.style.overflow = "initial";
            break;

        case "disabled":
            document.body.style.overflow = "hidden";
            break;

        default:
            document.body.style.overflow = "initial";
            break;
    }
}

openBtn.addEventListener('click', () => {
    toggleElements("active", elementsForToggling);
    toggleScroll("disabled");
});

closeBtn.addEventListener('click', () => {
    toggleElements("disabled", elementsForToggling);
    toggleScroll("active");
});

asideInfo.addEventListener('click', (e) => {
    if (e.target === asideInfo) {
        toggleElements("disabled", elementsForToggling);
        toggleScroll("active");
    }
});